// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Plus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
            <path
                fill="currentColor"
                d="M9.75,4.875 C9.75,5.28960943 9.41414094,5.6252346 9,5.6252346 L5.625,5.6252346 L5.625,9.0002346 C5.625,9.41484404 5.28914058,9.75 4.875,9.75 C4.46085942,9.75 4.125,9.41484404 4.125,9.0002346 L4.125,5.6252346 L0.75,5.6252346 C0.335859418,5.6252346 0,5.28960943 0,4.875 C0,4.46039057 0.335859418,4.12523425 0.75,4.12523425 L4.125,4.12523425 L4.125,0.750234604 C4.125,0.335625172 4.46085942,0 4.875,0 C5.28914058,0 5.625,0.335625172 5.625,0.750234604 L5.625,4.12523425 L9,4.12523425 C9.41484404,4.125 9.75,4.46015632 9.75,4.875 Z"
                transform="translate(.375 .625)"
            />
        </svg>
    );
};

export default React.memo(Plus);
